import resize from "../resize";
import Swiper, { Navigation, Lazy } from "swiper";
Swiper.use([Navigation, Lazy]);

const initTeachersMainSlider = () => {
  const slider = document.querySelector(".teachers--full .teachers-slider");
  let swiper = null;

  function init() {
    if (!swiper) {
      swiper = new Swiper(slider, {
        autoHeight: false,
        loop: false,
        lazy: true,
        breakpoints: {
          1681: {
            spaceBetween: 50,
            slidesPerView: 5,
          },
          1441: {
            spaceBetween: 40,
            slidesPerView: 5,
          },
          997: {
            spaceBetween: 50,
            slidesPerView: 4,
          },
          768: {
            spaceBetween: 30,
            slidesPerView: 4,
          },
          500: {
            spaceBetween: 50,
            slidesPerView: 2,
          },
          375: {
            spaceBetween: 50,
            slidesPerView: 1.7,
          },
          0: {
            spaceBetween: 50,
            slidesPerView: 1,
          },
        },
        navigation: {
          nextEl: ".teachers--full .slider-navigation__button--next",
          prevEl: ".teachers--full .slider-navigation__button--prev",
          disabledClass: "last",
        },
      });
    }
  }

  function destroy() {
    if (swiper) {
      swiper.destroy();
      swiper = null;
    }
  }

  function resizeSwiper() {
    window.innerWidth <= 767
      ? init()    
      : destroy();
  }

  slider && resizeSwiper();
  slider && resize(resizeSwiper);
};

export default initTeachersMainSlider;
